import { BaseComponent } from 'src/scripts/components/base-component'
import { isMobile } from 'src/scripts/utils/check-media'
import { $el } from 'src/scripts/utils/utils'

export class CloseCursor extends BaseComponent {
  overlaySelector: string
  isInited: boolean
  overlay: HTMLElement

  constructor() {
    super()

    this.overlaySelector = 'body-element'
    this.isInited = false
    this.overlay = $el(this.overlaySelector)
  }

  handleMouseMove = (event: MouseEvent): void => {
    this.toggleVisibility(event)
  }

  toggleVisibility = (event: MouseEvent): void => {
    const target = event.target
    const isOnOverlay = this.checkIsOnOverlay(target)

    if (isOnOverlay) {
      this.setVisible(event)
    } else {
      this.setHidden()
    }
  }

  setVisible(event: MouseEvent): void {
    document.body.style.cursor = 'none'
    this.toggleAttribute('visible', true)

    const { clientY: top, clientX: left } = event

    this.style.top = `${top}px`
    this.style.left = `${left}px`
  }

  setHidden(): void {
    document.body.style.cursor = ''
    this.toggleAttribute('visible', false)
  }

  setInitialVisibility = (clickEvent: MouseEvent): void => {
    const { clientY, clientX } = clickEvent
    const target = document.elementFromPoint(clientX, clientY)
    const isOnOverlay = this.checkIsOnOverlay(target)

    if (isOnOverlay) {
      this.setVisible(clickEvent)
    }
  }

  toggle(clickEvent?: MouseEvent): void {
    if (!isMobile()) {
      this.isInited ? this.deInit() : this.init(clickEvent)
    }
  }

  init = (clickEvent: MouseEvent): void => {
    window.addEventListener('mousemove', this.handleMouseMove)

    if (clickEvent?.clientX) {
      this.setInitialVisibility(clickEvent)
    }

    this.isInited = true
  }

  deInit(): void {
    window.removeEventListener('mousemove', this.handleMouseMove)
    this.setHidden()

    this.isInited = false
  }

  checkIsOnOverlay(target: EventTarget | null): boolean {
    return target === this.overlay
  }
}
